module.exports = __webpack_public_path__ + "static/media/Payme.ab5ad4e9.jpeg";